import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  href: "https://policies.google.com/privacy",
  class: "non-auth-footer__links",
  target: "_blank"
}
const _hoisted_2 = {
  href: "https://policies.google.com/terms",
  class: "non-auth-footer__links",
  target: "_blank"
}
const _hoisted_3 = { class: "non-auth-footer__desc mb-24" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!

  return (_openBlock(), _createBlock(_component_a_layout_footer, { class: "non-auth-footer" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, {
        justify: "center",
        class: "text-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            lg: 12,
            md: 18,
            xs: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_i18n_t, {
                keypath: "recaptchaTerms",
                tag: "div",
                class: "mb-10"
              }, {
                privacyURL: _withCtx(() => [
                  _createElementVNode("a", _hoisted_1, _toDisplayString(_ctx.t("privacyPolicy")), 1)
                ]),
                termsURL: _withCtx(() => [
                  _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.t("termsOfService")), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("loginPage.footerText", {
              brandName: _ctx.brandName,
              companyName: _ctx.companyName,
              companyWebsite: _ctx.companyWebsite,
            })), 1),
              _createVNode(_component_a_row, {
                class: "ant-row ant-row-center mb-25",
                gutter: 16
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: _ctx.config.privacyPolicyUrl,
                        target: "_blank",
                        class: "non-auth-footer__links-header"
                      }, _toDisplayString(_ctx.t("Privacy Policy")), 9, _hoisted_4)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: _ctx.config.cookiePolicyUrl,
                        target: "_blank",
                        class: "non-auth-footer__links-header"
                      }, _toDisplayString(_ctx.t("Cookie Policy")), 9, _hoisted_5)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: _ctx.config.termsWebsiteUseUrl,
                        target: "_blank",
                        class: "non-auth-footer__links-header"
                      }, _toDisplayString(_ctx.t("Terms of Website Use")), 9, _hoisted_6)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}